import Customer from "models/Customer";
import Survey from "models/Survey";
import SurveyLocale from "models/SurveyLocale";

export const INIT = "surveyProgress/INIT";
export const SET = "surveyProgress/SET";
export const SET_LOCALE = "surveyProgress/SET_LOCALE";
export const CHANGE_SEARCH_FORM = "surveyProgress/CHANGE_SEARCH_FORM";

export const initSurveyProgress = () => ({
  type: INIT
});
export const setSurveyProgress = (
  customer,
  survey,
  surveyLocales,
  deptResults
) => ({
  type: SET,
  customer: new Customer(customer),
  survey: new Survey(survey),
  surveyLocales: surveyLocales.map(sl => new SurveyLocale(sl)),
  deptResults
});

export const changeSearchForm = (key, value) => ({
  type: CHANGE_SEARCH_FORM,
  key,
  value
});
export const setLocale = localeId => ({
  type: SET_LOCALE,
  localeId
});

const initialState = {
  customer: new Customer(),
  survey: new Survey(),
  surveyLocales: [],
  selectedSurveyLocale: new SurveyLocale()
};

const surveyProgress = (state = initialState, action) => {
  switch (action.type) {
    case INIT: {
      return { ...initialState };
    }
    case SET: {
      const { customer, survey, surveyLocales, deptResults } = action;

      const selectedSurveyLocale = surveyLocales[0];
      return {
        ...state,
        survey,
        customer,
        surveyLocales,
        selectedSurveyLocale,
        deptResults
      };
    }
    case SET_LOCALE: {
      const { localeId } = action;
      const selectedSurveyLocale = state.surveyLocales.find(
        sl => sl.localeId === localeId
      );
      return { ...state, selectedSurveyLocale };
    }
    default:
      return state;
  }
};

export default surveyProgress;



// WEBPACK FOOTER //
// ./src/redux/modules/surveyProgress.js